module.exports = __webpack_public_path__ + "img/Flag_of_Chile.635701d4.svg";